/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormDocument
 */
export interface FormDocument {
    /**
     * Unique identifier for the form document
     * @type {number}
     * @memberof FormDocument
     */
    id: number;
    /**
     * ID of the template this document is based on
     * @type {number}
     * @memberof FormDocument
     */
    formTemplateId?: number | null;
    /**
     * Associated claim ID
     * @type {number}
     * @memberof FormDocument
     */
    claimId: number;
    /**
     * Company ID
     * @type {number}
     * @memberof FormDocument
     */
    companyId: number;
    /**
     * Homeowner name
     * @type {string}
     * @memberof FormDocument
     */
    recipientName: string;
    /**
     * Homeowner email
     * @type {string}
     * @memberof FormDocument
     */
    recipientEmail: string;
    /**
     * Current status of the form
     * @type {string}
     * @memberof FormDocument
     */
    status: FormDocumentStatusEnum;
    /**
     * When the form was signed
     * @type {Date}
     * @memberof FormDocument
     */
    signedAt?: Date | null;
    /**
     * UUID for public access to the form
     * @type {string}
     * @memberof FormDocument
     */
    accessToken: string;
    /**
     * Form expiration timestamp
     * @type {Date}
     * @memberof FormDocument
     */
    expiresAt: Date;
    /**
     * When the form was sent
     * @type {Date}
     * @memberof FormDocument
     */
    sentAt: Date;
    /**
     * When the form was first opened
     * @type {Date}
     * @memberof FormDocument
     */
    openedAt?: Date | null;
    /**
     * User ID who sent the form
     * @type {number}
     * @memberof FormDocument
     */
    sentBy: number;
    /**
     * 
     * @type {Date}
     * @memberof FormDocument
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof FormDocument
     */
    updatedAt: Date;
    /**
     * Template name (included when fetched via claim forms list with JOIN)
     * @type {string}
     * @memberof FormDocument
     */
    formTemplateName?: string;
}


/**
 * @export
 */
export const FormDocumentStatusEnum = {
    Sent: 'sent',
    Opened: 'opened',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;
export type FormDocumentStatusEnum = typeof FormDocumentStatusEnum[keyof typeof FormDocumentStatusEnum];


/**
 * Check if a given object implements the FormDocument interface.
 */
export function instanceOfFormDocument(value: object): value is FormDocument {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('recipientName' in value) || value['recipientName'] === undefined) return false;
    if (!('recipientEmail' in value) || value['recipientEmail'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('sentAt' in value) || value['sentAt'] === undefined) return false;
    if (!('sentBy' in value) || value['sentBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function FormDocumentFromJSON(json: any): FormDocument {
    return FormDocumentFromJSONTyped(json, false);
}

export function FormDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'formTemplateId': json['formTemplateId'] == null ? undefined : json['formTemplateId'],
        'claimId': json['claimId'],
        'companyId': json['companyId'],
        'recipientName': json['recipientName'],
        'recipientEmail': json['recipientEmail'],
        'status': json['status'],
        'signedAt': json['signedAt'] == null ? undefined : (new Date(json['signedAt'])),
        'accessToken': json['accessToken'],
        'expiresAt': (new Date(json['expiresAt'])),
        'sentAt': (new Date(json['sentAt'])),
        'openedAt': json['openedAt'] == null ? undefined : (new Date(json['openedAt'])),
        'sentBy': json['sentBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'formTemplateName': json['formTemplateName'] == null ? undefined : json['formTemplateName'],
    };
}

export function FormDocumentToJSON(json: any): FormDocument {
    return FormDocumentToJSONTyped(json, false);
}

export function FormDocumentToJSONTyped(value?: FormDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'formTemplateId': value['formTemplateId'],
        'claimId': value['claimId'],
        'companyId': value['companyId'],
        'recipientName': value['recipientName'],
        'recipientEmail': value['recipientEmail'],
        'status': value['status'],
        'signedAt': value['signedAt'] == null ? undefined : ((value['signedAt'] as any).toISOString()),
        'accessToken': value['accessToken'],
        'expiresAt': ((value['expiresAt']).toISOString()),
        'sentAt': ((value['sentAt']).toISOString()),
        'openedAt': value['openedAt'] == null ? undefined : ((value['openedAt'] as any).toISOString()),
        'sentBy': value['sentBy'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'formTemplateName': value['formTemplateName'],
    };
}

